export const OPTION_NOT_FOR_EVERYONE = 'option-not-for-everyone';
